import React, { Component } from 'react'
import PropTypes from 'prop-types'

import SvgIcon from 'components/common/SvgIcon'
import locationIcon from 'assets/icons/location-icon.svg'
import UserAvatarContainer from 'src/components/common/UserAvatarContainer'
import cn from 'classnames'
import { routerActions } from 'react-router-redux'

import styles from './time-poll-card.scss'
import { connect } from 'react-redux'

class TimePollCard extends Component {
  _getDate = (date, timeZoneSelected) => {
    const newDate = new Date(date)
    if (timeZoneSelected) return this._applyTimeZone(newDate, timeZoneSelected)
    return newDate
  }

  handleClick = () => {
    const { poll, dispatch, type } = this.props

    dispatch(
      routerActions.push({
        pathname: `/${type}/${poll.token}/`,
        state: {
          prevRoute: '/tp/timePoll'
        }
      })
    )
  }

  render() {
    const { poll } = this.props
    const isActive = poll.status === 'active'
    const date = this._getDate(poll.created_at)
    const formatDate = date => {
      const month = date.toLocaleString('default', { month: 'short' }).slice(0, 3)
      const day = date.getDate()
      return month + ' ' + day
    }

    return (
      <div className={styles['card']} onClick={this.handleClick}>
        {isActive ? (
          <div className={cn(styles['card__title'], styles['card__title--active'])}>open</div>
        ) : (
          <div className={cn(styles['card__title'], styles['card__title--closed'])}>closed</div>
        )}
        <div className={styles['card__text']}>
          <h3>{poll.name}</h3>
          {poll.apple_place && (
            <div className={styles['card__location']}>
              <SvgIcon icon={locationIcon} className={styles['icon']} />
              <span>peninsula cottage #360</span>
            </div>
          )}
          <p>
            <strong>Notes: </strong>
            {poll.notes}
          </p>
        </div>
        <div className={styles['card__info']}>
          <div className={styles['card__user']}>
            <UserAvatarContainer user={poll.creator || {}} size={20} />
            <span>{`${poll.creator.first_name} ${poll.creator.last_name}`}</span>
          </div>
          <span>created: {formatDate(date) || '--'}</span>
        </div>
      </div>
    )
  }
}

TimePollCard.propTypes = {
  dispatch: PropTypes.func,
  poll: PropTypes.object,
  type: PropTypes.string
}

export default connect()(TimePollCard)



// WEBPACK FOOTER //
// ./src/containers/time-poll/TimePollContainer/TimePoll/TimePollCard/TimePollCard.jsx